import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useGetAgendamiento } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { ROUTER_PATHS } from '@/shared';
import SaveAgendamientoSoportePymes from '../../shared/componente/save_agendamiento_sp/SaveAgendamientoSoportePymes';

export type EditAgendamientoSoportePymesProps = {};

const EditAgendamientoSoportePymes: React.FC<EditAgendamientoSoportePymesProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_agendamiento);
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;
  const { id } = useParams();
  const { data, isLoading } = useGetAgendamiento(id!);
  useLoaders(isLoading);

  if (isLoading ) return null;
  if (!data?.data?.id_agendamiento)
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <SaveAgendamientoSoportePymes
      title={"Editar Registro Agendado SP"}
      agendamiento={data.data}
    />
  );
};

export default EditAgendamientoSoportePymes;
